import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  CircularProgress,
  type CircularProgressProps,
} from '@mui/material'

export type LoadingIndicatorProps = Pick<
  CircularProgressProps,
  /**
   * @default 'indeterminate'
   */
  | 'variant'
  /**
   * progress value, useful for variant 'determinate' to indicate a certain progress
   * @default undefined
   */
  | 'value'
  | 'sx'

  /**
   * @default 16
   */
  | 'size'

  /**
   * @default 'primary'
   */
  | 'color'
>

/**
 * LoadingIndicator
 *
 * Demos:
 * - [LoadingIndicator](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-loadingindicator--docs)
 *
 */

export const LoadingIndicator = ({
  sx,
  color = 'primary',
  size = 16,
  variant = 'indeterminate',
  value,
}: LoadingIndicatorProps) => (
  <CircularProgress
    color={color}
    size={size}
    variant={variant}
    value={value}
    data-chromatic="ignore"
    aria-label="loading"
    sx={sx}
  />
)
